class FAQ {
    mainContainer;

    constructor(elm) {
        this.mainContainer = elm;
        this.answerToggle = this.mainContainer.querySelectorAll('.block-faq__answer-toggle');
        this.init();
    }

    init() {
        this.answerToggle.forEach(elm => elm.addEventListener('click', this.toggleAnswer));
    }

    toggleAnswer = (e) => {
        e.preventDefault();
        const parentCard = e.target.closest('.block-faq__cards-item');
        parentCard.classList.toggle('is-open');
    }

}

document.addEventListener('DOMContentLoaded', () => {
    const elm = document.querySelector('.block-faq');
    if (elm) {
        new FAQ(elm);
    }
})